module.exports = __webpack_public_path__ + "img/hs.a242e212.png";